const namespace = "pot";

export const TOTAL_POT = `${namespace}.totalPot`;
